<template>
  <Tag
    v-tooltip.bottom="tooltip"
    value="BETA"
    tabindex="0"
    role="note"
    :aria-label="tooltip"
    :pt="{ root: { class: 'bg-yellow-400/20 text-yellow-700 text-xs font-semibold tracking-wider px-2 py-0.5 rounded-md cursor-help' } }"
    data-testid="qc-beta-tag"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * RED-351 / design-spec §7 + §16.7 — the BETA marker.
 *
 * Non-negotiable properties, and each has a reason:
 *
 * - It renders on **every** state, including `failed` and the empty state: it
 *   lives in the screen's sticky top bar, which no state replaces and nobody
 *   can scroll past.
 * - It is **plain markup**. It is deliberately NOT tied to the `report-qc`
 *   flag, to a date or to a release: a human removes it on Toomas's word, and
 *   nothing else may remove it for him.
 * - The two mandatory Estonian sentences live in the tooltip. The visible
 *   `anna veast teada` mailto sits in the top bar's meta line (prototype v3),
 *   so the address is never more than one click away.
 *
 * The address comes from `config('report-qc.support_email')` through the
 * `reportQc` prop — one config value, never a string hardcoded in two
 * components (§7).
 */
const props = defineProps({
  supportEmail: { type: String, required: true },
})

const { t } = useI18n()

// Both mandatory sentences, verbatim (§7).
const tooltip = computed(() => [
  t('messages.evaluation.qualityCheck.beta.line1', { email: props.supportEmail }),
  t('messages.evaluation.qualityCheck.beta.line2'),
].join(' '))
</script>
